import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsPage } from './tabs.page';
import { AnalyseIconComponent } from './tab-icons/analyse.component';
import { NyttigIconComponent } from './tab-icons/nyttig.component';
import { BrukerkundeIconComponent } from './tab-icons/brukerkunde.component';
import { ContactIconComponent } from './tab-icons/contact.component';
import { MerIconComponent } from './tab-icons/mer.component';
import { ForbrukIconComponent } from './tab-icons/forbruk.component';
import { RegningIconComponent } from './tab-icons/regning.component';
import { KundetilgangModal } from './kundetilgang-modal/kundetilgang-modal.page';
import { ContactUsModalComponent } from './contact-us-modal/contact-us-modal.component';
import { RouterModule } from '@angular/router';
import { routes } from './tabs.routes';
import { AvtaleIconComponent } from './tab-icons/avtale.component';
import { ProfileIconComponent } from './tab-icons/profile.component';
import { EnodeIconComponent } from './tab-icons/enode.component';
import { SpotIconComponent } from './tab-icons/spot.component';
import { ComponentsModule } from '../shared/components.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    ContactUsModalComponent,
    KundetilgangModal,
    AnalyseIconComponent,
    NyttigIconComponent,
    BrukerkundeIconComponent,
    ContactIconComponent,
    MerIconComponent,
    ForbrukIconComponent,
    RegningIconComponent,
    AvtaleIconComponent,
    ProfileIconComponent,
    EnodeIconComponent,
    SpotIconComponent,
    ComponentsModule
  ],
  declarations: [TabsPage]
})
export class TabsPageModule {}
